import {Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter} from '@angular/core';


@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {
  @Input() titulo: string = 'Atenção';
  @Input() conteudo: string = '';
  @Input() textoBotaoPrimario: string = 'Ciente';
  @Input() mostrarBotaoSecundario: boolean = false;

  @Output() botaoPrimarioClicked = new EventEmitter<void>();
  @Output() botaoSecundarioClicked = new EventEmitter<void>();

  @ViewChild('modalRequerimentoGeral', { static: false }) modalElement!: ElementRef;

  constructor() { }

  ngOnInit() {
  }
  abrirModal() {
    // Usar setAttribute para adicionar os atributos necessários
    const modalEl = this.modalElement.nativeElement;
    modalEl.style.display = 'block';
    modalEl.classList.add('show');
    document.body.classList.add('modal-open');

    // Adicionar backdrop
    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    backdrop.id = 'modal-backdrop';
    document.body.appendChild(backdrop);
  }

  fecharModal() {
    const modalEl = this.modalElement.nativeElement;
    modalEl.style.display = 'none';
    modalEl.classList.remove('show');
    document.body.classList.remove('modal-open');

    // Remover backdrop
    const backdrop = document.getElementById('modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
  }

  onBotaoPrimarioClick() {
    this.botaoPrimarioClicked.emit();
  }

  onBotaoSecundarioClick() {
    this.botaoSecundarioClicked.emit();
  }
}
